import { scaleLinear } from 'd3'

export const domain = [0, 2.4]

export const xScale = (width, containerWidth) => {
    const x = scaleLinear(domain, [0, containerWidth])
    return x(width)
}

export const yScale = (height, containerHeight) => {
    const y = scaleLinear(domain, [containerHeight, 0])
    return y(height)
}
